import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LiveAnnouncer } from 'react-aria-live';

import { PageLayout } from '~/modules/navigation';
import RoutesProvider from '~/modules/common/routes';
import DrawerRouting from '~/modules/common/components/DrawerRouting';
import SessionExpiry from '~/modules/common/components/SessionExpiry';

import { SnackbarContainer, SnackbarProvider } from '../common/snackbar';
import withAppProviders from './withAppProviders';
import { useSentry, useSentryUserContext } from './useSentry';
import { useConfigureTimeZoneEffect } from './useConfigureTimeZoneEffect';
import AppContextProvider from './AppContextProvider';
import { useRecordUserLoginAccess } from './useRecordUserLoginAccess';
import { useInitGainsightPX } from './useGainsightPX';

export const App = () => {
  useConfigureTimeZoneEffect();
  useSentry();
  useSentryUserContext();
  useRecordUserLoginAccess();
  useInitGainsightPX();

  return (
    <AppContextProvider>
      <SnackbarProvider>
        <Router>
          <>
            <RoutesProvider>
              <LiveAnnouncer>
                <PageLayout />
              </LiveAnnouncer>{' '}
            </RoutesProvider>{' '}
            <DrawerRouting />
            <SessionExpiry />
          </>{' '}
        </Router>
        <SnackbarContainer />
      </SnackbarProvider>
    </AppContextProvider>
  );
};

export default withAppProviders(App);
